import { replaceSpanWithBrackets } from 'app/shared/components/loanManagement/loanActionsGroup/LoanActionsGroup.utils';
import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { selectDynamicFieldsOptions } from 'store/forms/selectors';

import {
  selectEmailTemplateCategories,
  selectEmailTemplateCategoriesArray,
} from './emailTemplateCategories.selectors';
import { selectActiveTemplateId } from './emailTemplatesControlUI.selectors';
import { getSystem } from './system.selectors';

const selectFetchedEmailTemplates = createSelector(
  getSystem,
  ({ emailTemplates }) => emailTemplates,
);

export const selectEmailTemplatesArray = createSelector(
  selectEmailTemplateCategoriesArray,
  categories =>
    _.flatMap(categories, ({ categoryTemplates, name }) =>
      categoryTemplates.map(template => ({ ...template, categoryName: name })),
    ),
);

export const selectEmailTemplatesMap = createSelector(
  selectEmailTemplatesArray,
  emailTemplatesArray => _.keyBy(emailTemplatesArray, 'id'),
);

export const selectActiveEmailTemplate = createSelector(
  [selectActiveTemplateId, selectFetchedEmailTemplates, selectDynamicFieldsOptions],
  (activeTemplateId, emailTemplates, dynamicFieldsOptions) =>
    emailTemplates[activeTemplateId] && {
      ...emailTemplates[activeTemplateId],
      subject: replaceSpanWithBrackets(
        emailTemplates[activeTemplateId]?.subject,
        dynamicFieldsOptions,
      ),
    },
);

export const selectEmailTemplatesByCategoryId = memoizeOne(categoryId =>
  createSelector(
    selectEmailTemplateCategories,
    categories => categories[categoryId].categoryTemplates,
  ),
);

export const selectEmailTemplatesExceptActive = createSelector(
  [selectActiveTemplateId, selectEmailTemplatesMap],
  (activeTemplateId, emailTemplates) => _.omit(emailTemplates, activeTemplateId),
);
